import { Directive, NgModule, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({ standalone: false,
  selector: '[docDisableContextMenu]'
})
export class DisableContextMenuDirective {

  @HostListener('contextmenu', ['$event']) onContextMenu(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

}

@NgModule({
  imports: [CommonModule],
  declarations: [DisableContextMenuDirective],
  exports: [DisableContextMenuDirective],
})
export class DisableContextMenuDirectiveModule {}